import { allFetch, ResultObj } from "../Domain";

/**
 * 車型查詢參數
 */
export interface CarTypeSearchParams {
    car_type: string;
    car_type_name: string;
    page: number;
    num_per_page: number;
};

/**
 * 車型查詢結果
 */
export interface CarTypeSearchResItem {
    car_type: string;
    car_type_name: string;
    company_rule: string;
    ct_id: string;
};

/**
 * @description 車型查詢
 */
export const CarTypeSearch = async (
    obj: CarTypeSearchParams
): Promise<ResultObj<CarTypeSearchResItem[]>> => {
    return await allFetch('CarType/CarTypeSearch', obj);
};


export interface CarTypeCreateParams { car_type: string, car_type_name: string, company_rule: string }
/**
 * @description 車型新建
 */
export const CarTypeCreate =
    async (obj: CarTypeCreateParams = { car_type: "", car_type_name: "", company_rule: '' }): Promise<ResultObj> => await allFetch('CarType/CarTypeCreate', obj);


export interface CarTypeDeleteParams { ct_id: string }
/**
 * @description 車型刪除
 */
export const CarTypeDelete =
    async (obj: CarTypeDeleteParams = { ct_id: "" }): Promise<ResultObj> => await allFetch('CarType/CarTypeDelete', obj);


export interface CarTypeDetailParams { ct_id: string }
/**
 * @description 車型細項
 */
export const CarTypeDetail =
    async (obj: CarTypeDetailParams = { ct_id: '' }): Promise<ResultObj> => await allFetch('CarType/CarTypeDetail', obj);


export interface CarTypeUpdateParams { ct_id: string, car_type: string, car_type_name: string, company_rule: string }
/**
 * @description 車型新增
 */
export const CarTypeUpdate =
    async (obj: CarTypeUpdateParams = { ct_id: "", car_type: "", car_type_name: "", company_rule: "", }): Promise<ResultObj> => await allFetch('CarType/CarTypeUpdate', obj);


/**
 * 車型代碼 的欄位
 */
export type CarTypeFormatParams = {
    ctf_id: string
    ct_id: string
    car_type: string
    car_type_name: string
    format_code: string
    format_name: string
};

export interface CarTypeFormatCreateParams { ct_id: string, format_code: string, format_name: string }
/**
 * @description 車型規格對照新建
 */
export const CarTypeFormatCreate =
    async (obj: CarTypeFormatCreateParams = { ct_id: '', format_code: '', format_name: '' }): Promise<ResultObj> => await allFetch('CarType/CarTypeFormatCreate', obj);


export interface CarTypeFormatSearchParams {
    ct_id?: string;
    car_type?: string;
    car_type_name?: string;
    format_code?: string;
    format_name?: string;
    page: number;
    num_per_page: number;
}
export interface CarTypeFormatSearchResItem {
    car_type: string;
    car_type_name: string;
    ct_id: string;
    ctf_id: string;
    format_code: string;
    format_name: string;
}
/**
 * @description 車型規格對照查詢
 */
export const CarTypeFormatSearch = async (
    obj: CarTypeFormatSearchParams
): Promise<ResultObj<CarTypeFormatSearchResItem[]>> => {
    return await allFetch('CarType/CarTypeFormatSearch', obj);
}

export interface CarTypeFormatUpdateParams { ctf_id: string, ct_id: string, format_code: string, format_name: string }
/**
 * @description 車型規格對照修改
 */
export const CarTypeFormatUpdate =
    async (obj: CarTypeFormatUpdateParams = { ctf_id: '', ct_id: '', format_code: '', format_name: '' }): Promise<ResultObj> => await allFetch('CarType/CarTypeFormatUpdate', obj);
/**
 * @description 車型規格對照細項(參數)
 */
export interface CarTypeFormatDetaileParams { ctf_id: string }
/**
 * @description 車型規格對照細項(回傳)
 */
export interface CarTypeFormatDetailResItem {
    car_type: string;
    car_type_name: string;
    ct_id: string;
    ctf_id: string;
    format_code: string;
    format_name: string;

}
/**
 * @description 車型規格對照細項
 */
export const CarTypeFormatDetail =
    async (obj: CarTypeFormatDetaileParams = { ctf_id: '' }):
        Promise<ResultObj<CarTypeFormatDetailResItem[]>> => await allFetch('CarType/CarTypeFormatDetail', obj);




export interface CarTypeFormatDeleteParams { ctf_id: string }
/**
 * @description 車型規格對照刪除
 */
export const CarTypeFormatDelete =
    async (obj: CarTypeFormatDeleteParams = { ctf_id: '' }): Promise<ResultObj> => await allFetch('CarType/CarTypeFormatDelete', obj);


/* ================================= */

/**
 * @description 車型規格訂價 的欄位
 */

export type CarTypeFormatPriceParams = {
    ctfp_id: string
    car_type: string
    car_type_name: string
    format_code: string
    format_name: string
    year: string
    car_type_price: string
    repayment_price: string
    valid_date: string
    invalid_date: string
};

/**
 * @description 車型規格訂價查詢
 * @param {string} car_type 車型代碼
 * @param {string} car_type_name 車型名稱
 * @param {string} format_code 規格代號
 * @param {string} format_name 規格名稱
 * @param {string} year 年式
 * @param {string} valid_date_start 可受訂起始日期起
 * @param {string} valid_date_end 可受訂起始日期迄
 * @param {string} invalid_date_start 不可受訂起始日期起
 * @param {string} invalid_date_end 不可受訂起始日期迄
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface CarTypeFormatPriceSearchParams {
    ct_id: string,
    ctf_id: string,
    car_type: string;
    car_type_name: string;
    format_code: string;
    format_name: string;
    year: string;
    year_age: string;
    valid_date_start: string;
    valid_date_end: string;
    invalid_date_start: string;
    invalid_date_end: string;
    page: number;
    num_per_page: number;
}
export interface CarTypeFormatPriceSearchResItem {
    car_type: string;
    car_type_name: string;
    car_type_price: string;
    ctf_id: string;
    ctfp_id: string;
    format_code: string;
    format_name: string;
    invalid_date: string;
    repayment_price: string;
    valid_date: string;
    year: string;
    year_age: string;
}
export const CarTypeFormatPriceSearch = async (
    obj: CarTypeFormatPriceSearchParams = {
        ct_id: '',
        ctf_id: '',
        car_type: "",
        car_type_name: "",
        format_code: "",
        format_name: "",
        year: "",
        year_age: "",
        valid_date_start: "",
        valid_date_end: "",
        invalid_date_start: "",
        invalid_date_end: "",
        page: 0,
        num_per_page: 10,
    },
): Promise<ResultObj<CarTypeFormatPriceSearchResItem[]>> => await allFetch("CarType/CarTypeFormatPriceSearch", obj);

/**
 * @description 車型規格訂價新建
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} year 年式
 * @param {string} car_type_price 車型訂價
 * @param {string} repayment_price 還款價
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */
export interface CarTypeFormatPriceCreateParams {
    ctf_id: string;
    year: string;
    year_age: string;
    car_type_price: string;
    repayment_price: string;
    valid_date: string;
    invalid_date: string;
}

export const CarTypeFormatPriceCreate = async (
    obj: CarTypeFormatPriceCreateParams = {
        ctf_id: "",
        year: "",
        year_age: "",
        car_type_price: "",
        repayment_price: "",
        valid_date: "",
        invalid_date: "",
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeFormatPriceCreate", obj);
/**
 * @description 車型規格訂價細項
 * @param {string} ctfp_id 流水號
 */
export interface CarTypeFormatPriceDetailParams {
    ctfp_id: string;
}

/**
 * @description 車型規格訂價細項(回傳)
 */
export interface CarTypeFormatPriceDetailResItem {
    ctf_id: string;
    ctfp_id: string;
    ct_id: string;
    year: string;
    year_age: string;
    car_type_price: string;
    car_type: string;
    car_type_name: string;
    repayment_price: string;
    valid_date: string;
    invalid_date: string
    format_code: string;
    format_name: string;

}
/**
 * @description 車型規格訂價細項
 */
export const CarTypeFormatPriceDetail = async (
    obj: CarTypeFormatPriceDetailParams = { ctfp_id: "" },
): Promise<ResultObj<CarTypeFormatPriceDetailResItem[]>> => await allFetch("CarType/CarTypeFormatPriceDetail", obj);

/**
 * @description 車型規格訂價刪除
 * @param {string} ctfp_id 流水號
 */
export interface CarTypeFormatPriceDeleteParams {
    ctfp_id: string;
}

export const CarTypeFormatPriceDelete = async (
    obj: CarTypeFormatPriceDeleteParams = { ctfp_id: "" },
): Promise<ResultObj> => await allFetch("CarType/CarTypeFormatPriceDelete", obj);

/**
 * @description 車型規格訂價修改
 * @param {string} ctfp_id 流水號
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} year 年式
 * @param {string} year_age 年份
 * @param {string} car_type_price 車型訂價
 * @param {string} repayment_price 還款價
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */
export interface CarTypeFormatPriceUpdateParams {
    ctfp_id: string,
    ctf_id: string,
    year: string,
    year_age: string,
    car_type_price: string,
    repayment_price: string,
    valid_date: string,
    invalid_date: string
}

export const CarTypeFormatPriceUpdate = async (
    obj: CarTypeFormatPriceUpdateParams = {
        ctfp_id: '',
        ctf_id: '',
        year: '',
        year_age: '',
        car_type_price: '',
        repayment_price: '',
        valid_date: '',
        invalid_date: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeFormatPriceUpdate", obj);

/**
 * @description 車型外裝加價 的欄位
 * @param {string} car_type 車型代碼
 * @param {string} car_type_name 車型名稱
 * @param {string} ce_id 外裝對照流水號
 * @param {string} ctep_id 流水號
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} exterior_price 外裝加價
 * @param {string} exterior_cost 外裝成本
 * @param {string} exterior_code 外裝顏色代碼
 * @param {string} exterior_color 外裝顏色名稱
 * @param {string} format_code 規格代碼
 * @param {string} format_name 規格名稱
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */
export interface CarTypeExteriorPriceParams {
    car_type: string;
    car_type_name: string;
    ce_id: string;
    ctep_id: string;
    ctf_id: string;
    exterior_price: string;
    exterior_cost: string;
    exterior_code: string;
    exterior_color: string;
    format_code: string;
    format_name: string;
    valid_date: string;
    invalid_date: string;
}

/**
 * @description 車型外裝加價查詢
 * @param {string} car_type 車型代碼
 * @param {string} car_type_name 車型名稱
 * @param {string} format_code 規格代碼
 * @param {string} format_name 規格名稱
 * @param {string} exterior_code 外裝顏色代碼
 * @param {string} exterior_color 外裝顏色名稱
 * @param {string} valid_date_start 可受訂起始日期起
 * @param {string} valid_date_end 可受訂起始日期迄
 * @param {string} invalid_date_start 不可受訂起始日期起
 * @param {string} invalid_date_end 不可受訂起始日期迄
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface CarTypeExteriorPriceSearchParams {
    car_type: string;
    car_type_name: string;
    format_code: string;
    format_name: string;
    exterior_code: string;
    exterior_color: string;
    valid_date_start: string;
    valid_date_end: string;
    invalid_date_start: string;
    invalid_date_end: string;
    page: number;
    num_per_page: number;
}

export const CarTypeExteriorPriceSearch = async (
    obj: CarTypeExteriorPriceSearchParams = {
        car_type: "",
        car_type_name: "",
        format_code: "",
        format_name: "",
        exterior_code: "",
        exterior_color: "",
        valid_date_start: "",
        valid_date_end: "",
        invalid_date_start: "",
        invalid_date_end: "",
        page: 1,
        num_per_page: 10,
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeExteriorPriceSearch", obj);


/**
 * @description 車型外裝加價新建
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} ce_id 外裝對照流水號
 * @param {string} exterior_price 外裝加價
 * @param {string} exterior_cost 外裝成本
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */
export interface CarTypeExteriorPriceCreateParams {
    ctf_id: string,
    ce_id: string,
    exterior_price: string,
    exterior_cost: string,
    valid_date: string,
    invalid_date: string
}

export const CarTypeExteriorPriceCreate = async (
    obj: CarTypeExteriorPriceCreateParams = {
        ctf_id: '',
        ce_id: '',
        exterior_price: '',
        exterior_cost: '',
        valid_date: '',
        invalid_date: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeExteriorPriceCreate", obj);



/**
 * @description 車型外裝加價修改
 * @param {string} ctep_id 流水號
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} ce_id 外裝對照流水號
 * @param {string} exterior_price 外裝加價
 * @param {string} exterior_cost 外裝成本
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */
export interface CarTypeExteriorPriceUpdateParams {
    ctep_id: string,
    ctf_id: string,
    ce_id: string,
    exterior_price: string,
    exterior_cost: string,
    valid_date: string,
    invalid_date: string
}

export const CarTypeExteriorPriceUpdate = async (
    obj: CarTypeExteriorPriceUpdateParams = {
        ctep_id: '',
        ctf_id: '',
        ce_id: '',
        exterior_price: '',
        exterior_cost: '',
        valid_date: '',
        invalid_date: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeExteriorPriceUpdate", obj);


/**
 * @description 車型外裝加價細項
 * @param {string} ctep_id 流水號
 */
export interface CarTypeExteriorPriceDetailParams {
    ctep_id: string;
}
/**
 * @description 車型外裝加價細項(參數)
 * @param {string} ctep_id 流水號
 */
export interface CarTypeExteriorPriceDetailResItem {
    car_type: string;
    car_type_name: string;
    ce_id: string;
    ctep_id: string;
    ctf_id: string;
    exterior_price: string;
    exterior_cost: string;
    exterior_code: string;
    exterior_color: string;
    format_code: string;
    format_name: string;
    valid_date: string;
    invalid_date: string;
}

export const CarTypeExteriorPriceDetail = async (
    obj: CarTypeExteriorPriceDetailParams = {
        ctep_id: ''
    },
): Promise<ResultObj<CarTypeExteriorPriceDetailResItem[]>> => await allFetch("CarType/CarTypeExteriorPriceDetail", obj);

/**
 * @description 車型外裝加價刪除
 * @param {string} ctep_id 流水號
 */
export interface CarTypeExteriorPriceDeleteParams {
    ctep_id: string
}

export const CarTypeExteriorPriceDelete = async (
    obj: CarTypeExteriorPriceDeleteParams = {
        ctep_id: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeExteriorPriceDelete", obj);





/**
 * @description 車型內裝加價 的欄位
 * @param {string} car_type 車型代碼
 * @param {string} car_type_name 車型名稱
 * @param {string} ci_id 外裝對照流水號
 * @param {string} ctip_id 流水號
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} interior_price 內裝加價
 * @param {string} interior_cost 內裝成本
 * @param {string} interior_code 內裝顏色代碼
 * @param {string} interior_color 內裝顏色名稱
 * @param {string} format_code 規格代碼
 * @param {string} format_name 規格名稱
 * @param {string} valid_date 可受訂日期
 * @param {string} invalid_date 不可受訂日期
 */
export interface CarTypeInteriorPriceParams {
    car_type: string;
    car_type_name: string;
    ci_id: string;
    ctip_id: string;
    ctf_id: string;
    interior_price: string;
    interior_cost: string;
    interior_code: string;
    interior_color: string;
    format_code: string;
    format_name: string;
    valid_date: string;
    invalid_date: string;
}

/**
 * @description 車型內裝加價查詢
 * @param {string} car_type 車型代碼
 * @param {string} car_type_name 車型名稱
 * @param {string} format_code 規格代碼
 * @param {string} format_name 規格名稱
 * @param {string} exterior_code 內裝顏色代碼
 * @param {string} exterior_color 內裝顏色名稱
 * @param {string} valid_date_start 可受訂起始日期起
 * @param {string} valid_date_end 可受訂起始日期迄
 * @param {string} invalid_date_start 不可受訂起始日期起
 * @param {string} invalid_date_end 不可受訂起始日期迄
 * @param {number} page 頁碼
 * @param {number} num_per_page 一頁幾筆
 */
export interface CarTypeInteriorPriceSearchParams {
    car_type: string;
    car_type_name: string;
    format_code: string;
    format_name: string;
    interior_code: string;
    interior_color: string;
    valid_date_start: string;
    valid_date_end: string;
    invalid_date_start: string;
    invalid_date_end: string;
    page: number;
    num_per_page: number;
}

export const CarTypeInteriorPriceSearch = async (
    obj: CarTypeInteriorPriceSearchParams = {
        car_type: "",
        car_type_name: "",
        format_code: "",
        format_name: "",
        interior_code: "",
        interior_color: "",
        valid_date_start: "",
        valid_date_end: "",
        invalid_date_start: "",
        invalid_date_end: "",
        page: 1,
        num_per_page: 10,
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeInteriorPriceSearch", obj);


/**
 * @description 車型內裝加價新建
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} ci_id 內裝對照流水號
 * @param {string} interior_price 內裝加價
 * @param {string} interior_cost 內裝成本
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */

export interface CarTypeInteriorPriceCreateParams {
    ctf_id: string;
    ci_id: string;
    interior_price: string;
    interior_cost: string;
    valid_date: string;
    invalid_date: string;
}

export const CarTypeInteriorPriceCreate = async (
    obj: CarTypeInteriorPriceCreateParams = {
        ctf_id: '',
        ci_id: '',
        interior_price: '',
        interior_cost: '',
        valid_date: '',
        invalid_date: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeInteriorPriceCreate", obj);



/**
 * @description 車型內裝加價修改
 * @param {string} ctip_id 流水號
 * @param {string} ctf_id 車型規格對照流水號
 * @param {string} ci_id 內裝對照流水號
 * @param {string} interior_price 內裝加價
 * @param {string} interior_cost 內裝成本
 * @param {string} valid_date 可受訂起始日期
 * @param {string} invalid_date 不可受訂起始日期
 */

export interface CarTypeInteriorPriceUpdateParams {
    ctip_id: string;
    ctf_id: string;
    ci_id: string;
    interior_price: string;
    interior_cost: string;
    valid_date: string;
    invalid_date: string;
}

export const CarTypeInteriorPriceUpdate = async (
    obj: CarTypeInteriorPriceUpdateParams = {
        ctip_id: '',
        ctf_id: '',
        ci_id: '',
        interior_price: '',
        interior_cost: '',
        valid_date: '',
        invalid_date: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeInteriorPriceUpdate", obj);

/**
 * @description 車型內裝加價細項
 * @param {string} ctip_id 流水號
 */

export interface CarTypeInteriorPriceDetailParams {
    ctip_id: string;
}

/**
 * @description 車型內裝加價細項(回傳)
 * @param {string} ctip_id 流水號
 */

export interface CarTypeInteriorPriceDetailResItem {
    car_type: string;
    car_type_name: string;
    ci_id: string;
    ctip_id: string;
    ctf_id: string;
    interior_price: string;
    interior_cost: string;
    interior_code: string;
    interior_color: string;
    format_code: string;
    format_name: string;
    valid_date: string;
    invalid_date: string;
}

export const CarTypeInteriorPriceDetail = async (
    obj: CarTypeInteriorPriceDetailParams = {
        ctip_id: '',
    },
): Promise<ResultObj<CarTypeInteriorPriceDetailResItem[]>> => await allFetch("CarType/CarTypeInteriorPriceDetail", obj);

/**
 * @description 車型內裝加價刪除
 * @param {string} ctip_id 流水號
 */

export interface CarTypeInteriorPriceDeleteParams {
    ctip_id: string;
}

export const CarTypeInteriorPriceDelete = async (
    obj: CarTypeInteriorPriceDeleteParams = {
        ctip_id: '',
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeInteriorPriceDelete", obj);



/**
 * 車型外裝 的欄位
 */
export type CarExteriorParams = {
    ce_id: string
    exterior_code: string;
    exterior_color: string;
};


/**
 * @description 車型外裝對照查詢
 * @param {string} exterior_code 外裝代碼
 * @param {string} exterior_color 外裝名稱
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface CarExteriorSearchParams {
    exterior_code: string;
    exterior_color: string;
    page: number;
    num_per_page: number;
}
export interface CarExteriorSearchResItem {
    ce_id: string
    exterior_code: string
    exterior_color: string
}

export const CarExteriorSearch = async (
    obj: CarExteriorSearchParams = {
        exterior_code: "",
        exterior_color: "",
        page: 1,
        num_per_page: 10,
    },
): Promise<ResultObj<CarExteriorSearchResItem[]>> => await allFetch("CarType/CarExteriorSearch", obj);

/**
 * @description 車型外裝新增
 * @param {string} exterior_code 外裝代碼
 * @param {string} exterior_color 外裝名稱
 */
export interface CarExteriorCreateParams {
    exterior_code: string;
    exterior_color: string;
}

export const CarExteriorCreate = async (
    obj: CarExteriorCreateParams = {
        exterior_code: '',
        exterior_color: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarExteriorCreate", obj);

/**
 * @description 車型外裝修改
 * @param {string} ce_id 流水號
 * @param {string} exterior_code 外裝代碼
 * @param {string} exterior_color 外裝名稱
 */
export interface CarExteriorUpdateParams {
    ce_id: string,
    exterior_code: string;
    exterior_color: string;
}

export const CarExteriorUpdate = async (
    obj: CarExteriorUpdateParams = {
        ce_id: '',
        exterior_code: '',
        exterior_color: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarExteriorUpdate", obj);
/**
 * @description 車型外裝對照細項(參數)
 * @param {string} ce_id 外裝流水號
 */
export interface CarExteriorDetailParams {
    ce_id: string,
}

/**
 * @description 車型外裝對照細項(回傳)
 * @param {string} ce_id 外裝流水號
 * @param {string} exterior_code 外裝代碼
 * @param {string} exterior_color 外裝名稱
 */
export interface CarExteriorDetailResItem {
    ce_id: string,
    exterior_code: string;
    exterior_color: string;
}

export const CarExteriorDetail = async (
    obj: CarExteriorDetailParams = {
        ce_id: '',
    },
): Promise<ResultObj<CarExteriorDetailResItem[]>> => await allFetch("CarType/CarExteriorDetail", obj);


/**
 * @description 車型外裝刪除
 * @param {string} ce_id 流水號
 */
export interface CarExteriorDeleteParams {
    ce_id: string,
}

export const CarExteriorDelete = async (
    obj: CarExteriorDeleteParams = {
        ce_id: '',
    },
): Promise<ResultObj> => await allFetch("CarType/CarExteriorDelete", obj);


/**
 * 車型內裝 的欄位
 */
export type CarInteriorParams = {
    ci_id: string
    interior_code: string;
    interior_color: string;
};

/**
 * @description 車型內裝對照查詢
 * @param {string} interior_code 內裝代碼
 * @param {string} interior_color 內裝名稱
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface CarInteriorSearchParams {
    interior_code: string;
    interior_color: string;
    page: number;
    num_per_page: number;
}
export interface CarInteriorSearchResItem {
    ci_id: string
    interior_code: string
    interior_color: string
}

export const CarInteriorSearch = async (
    obj: CarInteriorSearchParams = {
        interior_code: "",
        interior_color: "",
        page: 1,
        num_per_page: 10,
    },
): Promise<ResultObj<CarInteriorSearchResItem[]>> => await allFetch("CarType/CarInteriorSearch", obj);

/**
 * @description 車型內裝新增
 * @param {string} interior_code 內裝代碼
 * @param {string} interior_color 內裝名稱
 */
export interface CarInteriorCreateParams {
    interior_code: string,
    interior_color: string
}

export const CarInteriorCreate = async (
    obj: CarInteriorCreateParams = {
        interior_code: '',
        interior_color: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarInteriorCreate", obj);

/**
 * @description 車型內裝修改
 * @param {string} ci_id 內裝代碼
 * @param {string} interior_code 內裝代碼
 * @param {string} interior_color 內裝名稱
 */
export interface CarInteriorUpdateParams {
    ci_id: string,
    interior_code: string,
    interior_color: string
}

export const CarInteriorUpdate = async (
    obj: CarInteriorUpdateParams = {
        ci_id: '',
        interior_code: '',
        interior_color: ''
    },
): Promise<ResultObj> => await allFetch("CarType/CarInteriorUpdate", obj);


/**
 * @description 車型內裝對照細項
 * @param {string} ci_id 內裝代碼
 */
export interface CarInteriorDetailParams {
    ci_id: string,
}

/**
 * @description 車型內裝對照細項(回傳)
 */
export interface CarInteriorDetailResItem {
    ci_id: string,
    interior_code: string,
    interior_color: string
}

export const CarInteriorDetail = async (
    obj: CarInteriorDetailParams = {
        ci_id: '',
    },
): Promise<ResultObj<CarInteriorDetailResItem[]>> => await allFetch("CarType/CarInteriorDetail", obj);


/**
 * @description 車型內裝刪除
 * @param {string} ci_id 內裝代碼
 */
export interface CarInteriorDeleteParams {
    ci_id: string,
}

export const CarInteriorDelete = async (
    obj: CarInteriorDeleteParams = {
        ci_id: '',
    },
): Promise<ResultObj> => await allFetch("CarType/CarInteriorDelete", obj);




/**
 * @description 查詢車型相關(集合版)(參數)
 * @param {string} ct_id 內裝代碼
 * @param {string} year 年式
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface CarTypeSearchUnionParams {
    ct_id: string,
    year: string,
    year_age: string,
    page: number,
    num_per_page: number,
}
/**
 * @description 查詢車型相關(集合版)(回傳)
 */
export interface CarTypeSearchUnionResItem {
    car_type: string;
    car_type_name: string;
    car_type_price: string;
    ce_id: string;
    ci_id: string;
    ct_id: string;
    ctep_id: string;
    ctf_id: string;
    ctfp_id: string;
    ctip_id: string;
    ex_invalid_date: string;
    ex_valid_date: string;
    exterior_code: string;
    exterior_color: string;
    exterior_cost: string;
    exterior_price: string;
    format_code: string;
    format_name: string;
    in_invalid_date: string;
    in_valid_date: string;
    interior_code: string;
    interior_color: string;
    interior_cost: string;
    interior_price: string;
    invalid_date: string;
    repayment_price: string;
    valid_date: string;
    year: string;
    year_age: string;
}
/**
 * @description 查詢車型相關(集合版)
 */
export const CarTypeSearchUnion = async (
    obj: CarTypeSearchUnionParams = {
        ct_id: '',
        year: '',
        year_age: '',
        page: 1,
        num_per_page: 10
    },
): Promise<ResultObj<CarTypeSearchUnionResItem[]>> => await allFetch("CarType/CarTypeSearchUnion", obj);




/**
 * @description 車型相關整年移植(集合版)
 * @param {string} ct_id 車型流水號
 * @param {string} year_from 從哪年
 * @param {string} year_to 到哪年
 * @param {string} year_age_from 從哪年份
 * @param {string} year_age_to 到哪年份
 */

export interface CarTypeTransferParams {
    ct_id: string;
    year_from: string;
    year_to: string;
    year_age_from: string;
    year_age_to: string;
}

export const CarTypeTransfer = async (
    obj: CarTypeTransferParams = {
        ct_id: '',
        year_from: '',
        year_to: '',
        year_age_from: '',
        year_age_to: '',
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeTransfer", obj);



/**
 * @description 車型相關整年移植(集合版)
 * @param {string} CTFC 車型規格對照
 * @param {string} CTFPCU 車型規格訂價
 * @param {string} CTEPCU 車型外裝加價
 * @param {string} CTIPCU 車型內裝加價
 */

export interface CarTypeCreateUnionParams {
    CTFC: CarTypeFormatCreateParams;
    CTFPCU: CarTypeFormatPriceCreateParams;
    CTEPCU: CarTypeExteriorPriceCreateParams;
    CTIPCU: CarTypeInteriorPriceCreateParams;
}
/**
 * @description 車型相關整年移植(集合版)
 */
export const CarTypeCreateUnion = async (
    obj: CarTypeCreateUnionParams = {
        CTFC: {
            ct_id: '',
            format_code: '',
            format_name: ''
        },
        CTFPCU: {
            ctf_id: "",
            year: "",
            year_age: "",
            car_type_price: "",
            repayment_price: "",
            valid_date: "",
            invalid_date: "",
        },
        CTEPCU: {
            ctf_id: '',
            ce_id: '',
            exterior_price: '',
            exterior_cost: '',
            valid_date: '',
            invalid_date: ''
        },
        CTIPCU: {
            ctf_id: '',
            ci_id: '',
            interior_price: '',
            interior_cost: '',
            valid_date: '',
            invalid_date: ''
        },
    },
): Promise<ResultObj> => await allFetch("CarType/CarTypeCreateUnion", obj);
